import React from 'react';

import styles from './styles.module.scss';

interface I_SearchSkeletonProps {
    part: 'filter' | 'cards' | 'oneRow';
    device?: 'pc' | 'm';
}

const Skeleton = (props: I_SearchSkeletonProps) => {
    const { part, device } = props;

    if (part === 'filter') {
        return (
            <div className={styles.filtersSkeleton}>
                {Array.from(Array(2)).map((_, i, arr) => (
                    <div className={styles.blockSkeleton} key={i}>
                        <div className={styles.bar} />
                        <div className={styles.bar} />
                        <div className={styles.bar} />
                        {i !== arr.length - 1 ? (
                            <div className={`${styles.divider} ${styles.bar}`} />
                        ) : null}
                    </div>
                ))}
            </div>
        );
    }

    if (part === 'cards' && device) {
        return device === 'pc' ? (
            <div className={styles.cardsSkeleton}>
                {Array.from(Array(10)).map((_, i) => (
                    <div className={styles.cardSkeleton_pc} key={i}>
                        <div className={styles.contentSquare}>
                            <div className={styles.bar} />
                        </div>
                        <div className={styles.contentBlock}>
                            <div className={styles.infoBar}>
                                <div className={styles.bar} />
                                <div className={styles.bar} />
                            </div>
                            <div className={styles.signBar}>
                                <div className={styles.dayBars}>
                                    <div className={styles.bar} />
                                    <div className={styles.bar} />
                                    <div className={styles.bar} />
                                    <div className={styles.bar} />
                                </div>
                                <div className={styles.bar} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        ) : (
            <div className={styles.cardsSkeleton}>
                {Array.from(Array(10)).map((_, i) => (
                    <div className={styles.cardSkeleton_m} key={i}>
                        <div className={styles.contentSquare}>
                            <div className={styles.bar} />
                        </div>
                        <div className={styles.contentBlock}>
                            <div className={styles.infoBar}>
                                <div className={styles.bar} />
                                <div className={styles.bar} />
                                <div className={styles.bar} />
                            </div>
                            <div className={styles.signBar}>
                                <div className={styles.bar} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    if (part === 'oneRow') {
        return <div className={styles.bar} />;
    }

    return <div />;
};

export default Skeleton;
